import { z } from "zod";
import { VisualMediaSchema } from "../Media";
export const BackdropSchema = z.object({
    background: VisualMediaSchema.optional(),
    foreground: VisualMediaSchema.optional(),
    supportsUhdBackground: z.boolean().optional(),
});
//# sourceMappingURL=index.js.map